import React, { useState, useEffect } from "react";

const Layout = ({ children }) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return <div style={{ height: windowHeight, width: "100%" }}>{children}</div>;
};

export default Layout;
